<template>
  <div>
    <es-title title="PIX">
      <div slot="right">
        <div class="button is-info" @click="novo()"><icon name="plus"></icon></div>
      </div>
    </es-title>

    <es-filter :config="f1" :contasDebitosFiltradas="contasDebitosFiltradas" ref="filtro"></es-filter>
    <br>

    <div class="columns">
      <div class="column">
        <es-table :config="tabela" :rows="registros" @rowclick="detalhe">
          <div slot="buttons">
            <div class="button is-danger is-outlined" @click="relatorioPdf()">
              <icon name="file-pdf"></icon><span> Relatório PDF</span>
            </div>
            <div class="button is-success is-outlined" @click="relatorioXls()">
              <icon name="file-pdf"></icon><span> Relatório Xls</span>
            </div>
          </div>
        </es-table>
      </div>
    </div>

    <!-- Modal: Novo Pagamento PIX -->
    <es-modal title="Novo Pagamento PIX" :config="modal">
      <div class="columns is-multiline">

        <div class="column is-4">
          <div class="field">
            <label>Origem</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.data.origem" @change="getContas()">
                  <option value="0">Avulso</option>
                  <option value="5">Devolução</option>
                  <option value="3">Cancelamento</option>
                  <option value="2">Certidão</option>
                  <option value="4">Obrigação de fazer</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Apresentante</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.data.apresentante_id">
                  <option v-for="(item, i) in apresentantes" :key="i" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Conta Débito</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.data.conta_debito">
                  <option value="">Escolha uma conta</option>
                  <option v-for="(item, i) in contasDebito" :key="i" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-12">
          <hr style="margin: 4px 0;">
          <p class="has-text-weight-semibold" style="color:#32bcad; font-size:13px;">Dados PIX</p>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Tipo de Chave</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.data.tipo_chave" @change="form.data.chave_pix = ''">
                  <option value="">Selecione</option>
                  <option value="AG.CC">Agência e Conta</option>
                  <option value="EVP">Chave Aleatória</option>
                  <option value="TELEFONE">Telefone</option>
                  <option value="EMAIL">E-mail</option>
                  <option value="CPF">CPF</option>
                  <option value="CNPJ">CNPJ</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4" v-if="form.data.tipo_chave === 'AG.CC'">
          <div class="field">
            <label>Agência</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ex: 0001-2" v-model="form.data.agencia" @blur="getContasPorAgencia()">
            </div>
          </div>
        </div>

        <div class="column is-4" v-if="form.data.tipo_chave === 'AG.CC'">
          <div class="field">
            <label>Conta</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.data.favorecido_conta" @change="setFavorecidoPorConta()" :disabled="contasPorAgencia.length === 0">
                  <option value="">{{ contasPorAgencia.length ? 'Selecione a conta' : 'Informe a agência primeiro' }}</option>
                  <option v-for="(item, i) in contasPorAgencia" :key="i" :value="item.conta + (item.contadigito ? '-' + item.contadigito : '')">
                    {{ item.conta }}{{ item.contadigito ? '-' + item.contadigito : '' }} — {{ item.nome_favorecido }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-8" v-if="form.data.tipo_chave !== 'AG.CC'">
          <div class="field">
            <label>Chave PIX</label>
            <div class="control">
              <input class="input" type="text" placeholder="Informe a chave PIX" v-model="form.data.chave_pix" @blur="consultarChave()">
            </div>
          </div>
        </div>

        <div class="column is-12">
          <hr style="margin: 4px 0;">
          <p class="has-text-weight-semibold" style="font-size:13px;">Favorecido</p>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Documento</label>
            <div class="control">
              <the-mask class="input" placeholder="CPF/CNPJ" v-model="form.data.documento" :mask="['###.###.###-##', '##.###.###/####-##']" @blur.native="getFavorecido()" />
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label>Nome do Favorecido</label>
            <div class="control">
              <input class="input" type="text" placeholder="Nome" v-model="form.data.favorecido" :disabled="form.data.favorecido_readonly">
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Banco</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ex: 341" v-model="form.data.banco" :disabled="form.data.banco_readonly">
            </div>
          </div>
        </div>

        <div class="column is-4" v-if="form.data.tipo_chave !== 'AG.CC'">
          <div class="field">
            <label>Agência</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ex: 0001-2" v-model="form.data.agencia" :disabled="form.data.agencia_readonly">
            </div>
          </div>
        </div>

        <div class="column is-4" v-if="form.data.tipo_chave !== 'AG.CC'">
          <div class="field">
            <label>Conta</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ex: 00000-0" v-model="form.data.favorecido_conta" :disabled="form.data.conta_readonly">
            </div>
          </div>
        </div>

        <div class="column is-12">
          <hr style="margin: 4px 0;">
          <p class="has-text-weight-semibold" style="font-size:13px;">Pagamento</p>
        </div>

        <div class="column is-4">
          <div class="field">
            <label>Valor</label>
            <div class="control">
              <input class="input" type="text" placeholder="R$ 0,00" v-model="form.data.valor" @keyup="aplicaMascaraMoeda()">
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label>Identificação</label>
            <div class="control">
              <input class="input" type="text" placeholder="Código / Referência" v-model="form.data.codigo">
            </div>
          </div>
        </div>

        <div class="column is-12">
          <div class="field">
            <label>Observações <span style="color:#aaa; font-size:11px;">(uso interno)</span></label>
            <div class="control">
              <textarea class="textarea" placeholder="Observações internas..." v-model="form.data.observacao" rows="2"></textarea>
            </div>
          </div>
        </div>

      </div>
    </es-modal>

    <!-- Modal: Detalhe -->
    <es-modal :title="'PIX ID: ' + registro.id" :config="modalDetalhe">
      <div class="columns">
        <div class="column is-6">
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Tipo Chave</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.tipo_chave" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Chave PIX</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.chave_pix" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Favorecido</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.favorecido" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Documento</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.documento" readonly>
            </p></div></div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Valor</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.valor" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Data</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.data | date" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Status</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.status" readonly>
            </p></div></div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal"><label class="label">Conta Débito</label></div>
            <div class="field-body"><div class="field"><p class="control">
              <input class="input is-static" type="text" :value="registro.conta_debito_numero" readonly>
            </p></div></div>
          </div>
        </div>
      </div>
    </es-modal>

    <es-loading :show="loading"></es-loading>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/utils'

export default {
  data () {
    return {
      registros: [],
      registro: {},
      apresentantes: [{value: 0, text: 'Nenhum Apresentante'}],
      contasDebito: [],
      contasDebitosFiltradas: [],
      contasPorAgencia: [],
      form: {
        data: {
          origem: '0',
          apresentante_id: 0,
          conta_debito: '',
          tipo_chave: '',
          chave_pix: '',
          documento: '',
          favorecido: '',
          banco: '',
          agencia: '',
          favorecido_conta: '',
          valor: '',
          codigo: '',
          favorecido_readonly: false,
          banco_readonly: false,
          agencia_readonly: false,
          conta_readonly: false
        }
      },
      f1: {
        fields: [
          {name: 'id', label: 'ID', placeholder: 'ID', width: 1, type: 'text'},
          {name: 'data', label: 'Data Inicial', type: 'data', width: 1, value: ''},
          {name: 'dataF', label: 'Data Final', type: 'dataF', width: 1, value: ''},
          {
            name: 'apresentante_id',
            label: 'Apresentante',
            type: 'select',
            width: 2,
            values: [{value: 0, text: 'Todos Apresentante'}]
          },
          {
            name: 'UF',
            label: 'Estado',
            placeholder: 'UF',
            type: 'select',
            width: 1,
            values: [
              {value: '0', text: 'Todos'},
              {value: 'AC', text: 'Acre'},
              {value: 'AL', text: 'Alagoas'},
              {value: 'AP', text: 'Amapá'},
              {value: 'AM', text: 'Amazonas'},
              {value: 'BA', text: 'Bahia'},
              {value: 'CE', text: 'Ceará'},
              {value: 'DF', text: 'Distrito Federal'},
              {value: 'ES', text: 'Espírito Santo'},
              {value: 'GO', text: 'Goiás'},
              {value: 'MA', text: 'Maranhão'},
              {value: 'MT', text: 'Mato Grosso'},
              {value: 'MS', text: 'Mato Grosso do Sul'},
              {value: 'MG', text: 'Minas Gerais'},
              {value: 'PA', text: 'Pará'},
              {value: 'PB', text: 'Paraíba'},
              {value: 'PR', text: 'Paraná'},
              {value: 'PE', text: 'Pernambuco'},
              {value: 'PI', text: 'Piauí'},
              {value: 'RJ', text: 'Rio de Janeiro'},
              {value: 'RN', text: 'Rio Grande do Norte'},
              {value: 'RS', text: 'Rio Grande do Sul'},
              {value: 'RO', text: 'Rondônia'},
              {value: 'RR', text: 'Roraima'},
              {value: 'SC', text: 'Santa Catarina'},
              {value: 'SP', text: 'São Paulo'},
              {value: 'SE', text: 'Sergipe'},
              {value: 'TO', text: 'Tocantins'}
            ]
          },
          {name: 'documento', label: 'Documento', placeholder: 'CPF/CNPJ', type: 'document', width: 2, value: ''},
          {
            name: 'conta_id',
            label: 'Contas',
            type: 'contaSelect',
            width: 2,
            values: [{value: 0, text: 'Escolha uma conta'}]
          },
          {name: 'conta', label: 'Conta', placeholder: 'numero conta', type: 'contaText', width: 1, value: ''},
          {name: 'numero', label: 'Nº de Pagamento', placeholder: 'Nº de Pagamento', width: 2, type: 'text'}
        ],
        button: {label: 'Localizar', side: 'right', action: this.localizar},
        buttonLimpar: {label: 'Limpar', side: 'right', action: this.limparFiltro},
        select: {action: ''}
      },
      tabela: {
        fields: [
          {name: 'id', label: 'ID', align: 'right'},
          {name: 'numero', label: 'Nº de Pagamento PIX', align: 'right'},
          {name: 'data', label: 'Data', type: 'date'},
          {name: 'tipo_chave', label: 'Tipo Chave', align: 'center'},
          {name: 'chave_pix', label: 'Chave PIX'},
          {name: 'favorecido', label: 'Favorecido'},
          {name: 'documento', label: 'Documento', type: 'documento'},
          {name: 'valor', label: 'Valor', type: 'currency'},
          {name: 'status', label: 'Status', align: 'center'},
          {name: 'apresentante_id', label: 'Apresentante'},
          {name: 'uf', label: 'UF', align: 'center'},
          {name: 'conta_debito_numero', label: 'Conta Débito', align: 'center'}
        ],
        sum: 'valor',
        key: 'id',
        button: true
      },
      modal: {
        active: false,
        width: 'large',
        cancel: this.cancelar,
        save: this.salvar
      },
      modalDetalhe: {
        active: false,
        width: 'large'
      }
    }
  },
  created () {
    if (this.$session.get('authenticated')) {
      this.getApresentantes()
    }
    this.getContasDebito()
  },
  mounted () {
    this.$refs.filtro.filter = {apresentante_id: 0, UF: '0', conta_id: 0}
    var data = new Date()
    var dia = data.getDate().toString().padStart(2, '0')
    var mes = (data.getMonth() + 1).toString().padStart(2, '0')
    var ano = data.getFullYear()
    this.$refs.filtro['data'] = dia + '/' + mes + '/' + ano
    this.$refs.filtro['dataF'] = dia + '/' + mes + '/' + ano
  },
  methods: {
    novo () {
      this.form.data = {
        origem: '0',
        apresentante_id: 0,
        conta_debito: '',
        tipo_chave: '',
        chave_pix: '',
        documento: '',
        favorecido: '',
        banco: '',
        agencia: '',
        favorecido_conta: '',
        valor: '',
        codigo: '',
        observacao: '',
        favorecido_readonly: false,
        banco_readonly: false,
        agencia_readonly: false,
        conta_readonly: false
      }
      this.contasPorAgencia = []
      this.getContas()
      this.modal.active = true
    },
    cancelar () {
      this.modal.active = false
    },
    salvar() {
      if (!this.form.data.tipo_chave) {
        this.error('Selecione o tipo de chave PIX.')
        return
      }
      if (this.form.data.tipo_chave === 'AG.CC') {
        if (!this.form.data.agencia) {
          this.error('Informe a agência.')
          return
        }
        if (!this.form.data.favorecido_conta) {
          this.error('Informe a conta.')
          return
        }
        this.form.data.chave_pix = this.form.data.agencia + '/' + this.form.data.favorecido_conta
      } else if (!this.form.data.chave_pix) {
        this.error('Informe a chave PIX.')
        return
      }
      if (!this.form.data.favorecido) {
        this.error('Informe o favorecido.')
        return
      }
      if (!this.form.data.valor || this.form.data.valor === '0' || this.form.data.valor === '0,00') {
        this.error('Informe o valor do pagamento.')
        return
      }
      if (!this.form.data.conta_debito) {
        this.error('Selecione a conta débito.')
        return
      }

      this.showLoading()
      
      const payload = JSON.parse(JSON.stringify(this.form.data))
      
      payload.valor = payload.valor.replace(/\./g, '').replace(',', '.')

      axios.post('api/v1/batimento/pix/pagar', payload)
        .then((res) => {
          this.closeLoading()
          this.modal.active = false
          this.success('Pagamento PIX salvo! ID: ' + res.data.id + '. Aguardando aprovação no Pagfor.')
          this.$router.push('/pagfor')
        })
        .catch((err) => {
          this.closeLoading()
          const mensagemErro = err.response?.data?.erro || 'Erro interno ao processar PIX'
          this.error(mensagemErro)
          console.error(err)
        })
    },
    getContasPorAgencia () {
      this.contasPorAgencia = []
      this.form.data.favorecido_conta = ''
      this.form.data.favorecido = ''
      this.form.data.banco = ''
      this.form.data.documento = ''

      if (!this.form.data.agencia) return

      const agencia = this.form.data.agencia.replace(/\D/g, '')
      this.showLoading()
      axios.get(`api/v1/batimento/pix/favorecido/agencia/${agencia}`)
        .then((res) => {
          this.closeLoading()
          if (res.data && res.data.length > 0) {
            this.contasPorAgencia = res.data
          } else {
            this.warning('Nenhuma conta encontrada para esta agência.')
          }
        })
        .catch(() => {
          this.closeLoading()
          this.error('Erro ao buscar contas.')
        })
    },
    setFavorecidoPorConta () {
      const selecionado = this.contasPorAgencia.find(item => {
        const contaFormatada = item.conta + (item.contadigito ? '-' + item.contadigito : '')
        return contaFormatada === this.form.data.favorecido_conta
      })
      if (!selecionado) return
      this.form.data.favorecido = selecionado.nome_favorecido
      this.form.data.banco      = selecionado.banco
      this.form.data.documento  = selecionado.nm_nr_cpfcnpj
    },
    getFavorecidoPorAgenciaConta () {
      if (!this.form.data.agencia || !this.form.data.favorecido_conta) return

      const agencia = this.form.data.agencia.replace(/\D/g, '')
      const conta = this.form.data.favorecido_conta.replace(/\D/g, '')

      this.showLoading()
      axios.get(`api/v1/batimento/pix/favorecido/agencia-conta/${agencia}/${conta}`)
        .then((res) => {
          this.closeLoading()
          if (res.data && res.data.length > 0) {
            const d = res.data[0]
            this.form.data.favorecido = d.nome_favorecido
            this.form.data.banco      = d.banco
            this.form.data.documento  = d.nm_nr_cpfcnpj
          } else {
            this.warning('Favorecido não encontrado para esta agência/conta.')
          }
        })
        .catch(() => {
          this.closeLoading()
          this.error('Erro ao buscar favorecido.')
        })
    },
    consultarChave () {
      if (!this.form.data.chave_pix) return
      // TODO: consultar dados do favorecido pela chave PIX
      // axios.get(`api/v1/batimento/pix/chave/${this.form.data.tipo_chave}/${this.form.data.chave_pix}`).then((res) => {
      //   this.form.data.favorecido           = res.data.nome
      //   this.form.data.documento            = res.data.documento
      //   this.form.data.banco                = res.data.banco
      //   this.form.data.agencia              = res.data.agencia
      //   this.form.data.favorecido_conta     = res.data.conta
      //   this.form.data.favorecido_readonly  = true
      //   this.form.data.banco_readonly       = true
      //   this.form.data.agencia_readonly     = true
      //   this.form.data.conta_readonly       = true
      // }).catch(() => {
      //   this.warning('Chave PIX não encontrada. Preencha os dados manualmente.')
      // })
    },
    getFavorecido () {
      var documento = utils.documentoNumero(this.form.data.documento)

      if (!documento || (documento.length !== 11 && documento.length !== 14)) return

      if (!utils.validarDocumento(documento)) {
        this.error('Documento inválido.')
        this.limparFavorecido()
        return
      }

      this.showLoading()

      axios.get(`api/v1/batimento/pix/favorecido/${documento}`)
        .then((res) => {

          if (res.data && res.data.length > 0) {

            var d = res.data[0]

            this.form.data.favorecido          = d.nome_favorecido
            this.form.data.banco               = d.banco
            this.form.data.agencia             = d.agencia + (d.agdigito ? '-' + d.agdigito : '')
            this.form.data.favorecido_conta    = d.conta + (d.contadigito ? '-' + d.contadigito : '')
            this.form.data.cd_conta            = d.cd_conta
            this.form.data.cd_cartorio         = d.cd_cartorio

            this.form.data.favorecido_readonly = true
            this.form.data.banco_readonly      = true
            this.form.data.agencia_readonly    = true
            this.form.data.conta_readonly      = true

          } else {
            this.warning('Favorecido não encontrado.')
            this.limparFavorecido()
          }

          this.closeLoading()
        })
        .catch((err) => {
          console.error(err)
          this.error('Erro ao buscar favorecido.')
          this.closeLoading()
        })
    },
    limparFavorecido () {
      this.form.data.favorecido          = ''
      this.form.data.banco               = ''
      this.form.data.agencia             = ''
      this.form.data.favorecido_conta    = ''
      this.form.data.favorecido_readonly = false
      this.form.data.banco_readonly      = false
      this.form.data.agencia_readonly    = false
      this.form.data.conta_readonly      = false
    },
    detalhe (idx) {
      this.registro = Object.assign({}, this.registros[idx])
      this.modalDetalhe.active = true
    },
    getApresentantes () {
      axios.get('api/v1/batimento/apresentantes/filtro/').then((res) => {
        for (var i in res.data) {
          var item = {value: res.data[i].id, text: res.data[i].codigo + ' - ' + res.data[i].nome}
          this.apresentantes.push(item)
          this.f1.fields[3].values.push({value: res.data[i].codigo, text: res.data[i].codigo + ' - ' + res.data[i].nome})
        }
      })
    },
    getContas () {
      const origem = this.form.data.origem
      axios.get(`api/v1/batimento/contas_debito/${origem}`).then((res) => {
        this.contasDebito = res.data.map(c => ({value: c, text: c}))
        this.form.data.conta_debito = ''
      })
    },
    getContasDebito () {
      this.contasDebito = []
    },
    aplicaMascaraMoeda () {
      var v = this.form.data.valor || ''
      v = v.replace(/\D/g, '')
      v = v.replace(/(\d{1})(\d{14})$/, '$1.$2')
      v = v.replace(/(\d{1})(\d{11})$/, '$1.$2')
      v = v.replace(/(\d{1})(\d{8})$/, '$1.$2')
      v = v.replace(/(\d{1})(\d{5})$/, '$1.$2')
      v = v.replace(/(\d{1})(\d{1,2})$/, '$1,$2')
      this.form.data.valor = v
    },
    limparFiltro (arg) {
      this.$refs.filtro.filter = {apresentante_id: 0, UF: '0', conta_id: 0, id: '', documento: '', numero: '', conta: ''}
      var data = new Date()
      var dia = data.getDate().toString().padStart(2, '0')
      var mes = (data.getMonth() + 1).toString().padStart(2, '0')
      var ano = data.getFullYear()
      this.$refs.filtro['data'] = dia + '/' + mes + '/' + ano
      this.$refs.filtro['dataF'] = dia + '/' + mes + '/' + ano
      this.f1.fields[1].value = ''
      this.f1.fields[2].value = ''
      this.contasDebitosFiltradas = []
      this.registros = []
    },
    localizar (arg) {
      var data = arg.data
      var dataF = arg.dataF
      if (!data || !dataF) {
        this.error('Preencha os dois campos Data')
        return
      }
      this.showLoading()
      if (arg.documento) {
        arg.documento = utils.documentoNumero(arg.documento)
      }
      axios.post('api/v1/batimento/pix/relatorio', arg)
        .then((res) => {
          this.registros = res.data
          this.closeLoading()
          if (!res.data.length) this.error('Filtro não possui dados')
        })
        .catch((err) => {
          this.error(err.response?.data || 'Erro ao buscar registros')
          this.closeLoading()
        })
    },
    relatorioPdf () {
      this.showLoading()
      var dt = this.f1.fields[1].value
      var dtf = this.f1.fields[2].value
      var aprecod = this.f1.fields[3].value || '0'
      var UF = this.f1.fields[4].value || '0'
      var doc = (this.f1.fields[5].value || '') === '' ? '0' : this.f1.fields[5].value
      var contaid = this.f1.fields[6].value || '0'
      if (!dt || !dtf) { this.error('Preencha os dois campos Data'); this.closeLoading(); return }
      var dtFmt = dt.split('/').reverse().join('-')
      var dtfFmt = dtf.split('/').reverse().join('-')
      axios.get(`api/v1/batimento/pix/relatorio/pdf/${dtFmt}/${dtfFmt}/${aprecod}/${UF}/${doc}/${contaid}`).then((res) => {
        var uriContent = 'data:application/pdf,' + escape(res.data)
        var link = document.createElement('a')
        link.href = uriContent
        link.download = 'Rel_Pix.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.closeLoading()
      }).catch((err) => { this.error(err.response?.data || 'Erro ao gerar PDF'); this.closeLoading() })
    },
    relatorioXls () {
      this.showLoading()
      var dt = this.f1.fields[1].value
      var dtf = this.f1.fields[2].value
      var aprecod = this.f1.fields[3].value || '0'
      var UF = this.f1.fields[4].value || '0'
      var doc = (this.f1.fields[5].value || '') === '' ? '0' : this.f1.fields[5].value
      var contaid = this.f1.fields[6].value || '0'
      if (!dt || !dtf) { this.error('Preencha os dois campos Data'); this.closeLoading(); return }
      var dtFmt = dt.split('/').reverse().join('-')
      var dtfFmt = dtf.split('/').reverse().join('-')
      axios.get(`api/v1/batimento/pix/relatorio/xls/${dtFmt}/${dtfFmt}/${aprecod}/${UF}/${doc}/${contaid}`, {responseType: 'arraybuffer'}).then((res) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([res.data]))
        link.download = 'Relatorio_Pix.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.closeLoading()
      }).catch((err) => { this.error(err.response?.data || 'Erro ao gerar XLS'); this.closeLoading() })
    }
  }
}
</script>
